import { useEffect, useRef } from 'react';
import { useNCTextLocalizer } from '../../../locale/useNCTextLocalizer';
import { Dialog } from '../../Dialog';
import { DualSelector } from '../../DualSelector';
import { useIconA11yInfo } from '../../Icon/useIconA11yInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export const ManageColumnsDialog = props => {
  const localize = useNCTextLocalizer('Table');
  const updatedOrderedColumnKeysRef = useRef([]);
  const orderedColumnKeys = props.orderedColumnKeys ?? [];
  const hideManageColumnsSearch = props.hideManageColumnsSearch !== undefined ? props.hideManageColumnsSearch : false;
  const hideManageColumnsSelectedSearch = props.hideManageColumnsSelectedSearch !== undefined ? props.hideManageColumnsSelectedSearch : true;
  useEffect(() => {
    if (!props.isOpen) {
      updatedOrderedColumnKeysRef.current = props.orderedColumnKeys ?? [];
    }
  }, [props.orderedColumnKeys, props.isOpen]);
  const iconInfo = useIconA11yInfo();
  const getDualSelectorItemByColumnKey = columnKey => {
    const column = props.columns.find(({
      key
    }) => key === columnKey);
    let columnLabel = column?.label;
    if (column && !columnLabel && column.icon) {
      columnLabel = iconInfo({
        icon: column.icon
      }).ariaLabel;
    }
    return {
      icon: column?.icon,
      columnLabel,
      columnKey,
      alwaysSelected: column?.rowHeaderColumn === true
    };
  };
  const displayedColumns = orderedColumnKeys.map(getDualSelectorItemByColumnKey);
  const hiddenColumns = props.columns.filter(({
    key
  }) => !orderedColumnKeys.includes(key)).map(({
    key
  }) => getDualSelectorItemByColumnKey(key));
  return /*#__PURE__*/_jsx(Dialog, {
    isOpen: props.isOpen,
    title: localize('manageColumnsDialog.title'),
    firstAction: {
      text: localize('manageColumnsDialog.confirmButton.label'),
      onPress: () => props.onConfirm?.(updatedOrderedColumnKeysRef.current)
    },
    dismissAction: {
      text: localize('manageColumnsDialog.dismissButton.label'),
      onPress: () => {
        updatedOrderedColumnKeysRef.current = props.orderedColumnKeys ?? [];
        props.onDismiss?.();
      }
    },
    onClose: props.onClose,
    focusLockProps: {
      onDeactivation: props.onFocusDeactivation
    },
    size: {
      width: '48rem',
      height: '40rem',
      maxWidth: 'calc(100% - 4rem)',
      maxHeight: 'calc(100% - 4rem)'
    },
    testId: props.testId,
    children: /*#__PURE__*/_jsx(DualSelector, {
      style: {
        height: '100%'
      },
      type: "list",
      mode: "move",
      dataFieldKeys: ['columnLabel'],
      sourceAttribute: [{
        label: localize('manageColumnsDialog.hiddenColumns.label'),
        data: hiddenColumns,
        hideSearch: hideManageColumnsSearch
      }],
      targetAttribute: [{
        label: localize('manageColumnsDialog.displayedColumns.label'),
        data: displayedColumns,
        hideSearch: hideManageColumnsSelectedSearch
      }],
      onTargetChange: selectedItems => {
        updatedOrderedColumnKeysRef.current = selectedItems.map(({
          columnKey
        }) => columnKey);
      },
      testId: props.testId
    })
  });
};
//# sourceMappingURL=ManageColumnsDialog.js.map